export class FileReaderUtilities {
    /**
     * This method returns the `FileReader` registered in zone.js.
     * If we are not using this fileReader the events from the cordova-plugin-file are not fired sporadically(onload, onloadend)
     * For more information check the links
     * https://github.com/ionic-team/ionic-native/issues/505
     * https://github.com/ionic-team/capacitor/issues/1564
     */
    public static getFileReader(): FileReader {
        const fileReader = new FileReader();
        // eslint-disable-next-line
        const zoneOriginalInstance = (fileReader as any)._realReader?.__zone_symbol__originalInstance;

        return zoneOriginalInstance || fileReader;
    }
}
